export class EdpURIs {
  //Utilities
  public static systemOptions = '/edp/v1/utilities/systemOptions';

  /**Below is our deprecated way of defining endpoints.  We now prefer to write out the full endpoint as above for
   * improved readability and documentation.
   * **/

  //Base
  public static edpBase = (version: string = '1') => `/edp/v${version}`;

  //Facility Endpoints
  public static facility = (version: string = '1') => `${EdpURIs.edpBase(version)}/facilities`;
  public static facilityOptions = (version: string = '1') => `${EdpURIs.facility(version)}/options`;

  //Additional Order Message Fields
  public static additionalOrderMessageFields = () => `${EdpURIs.facilityOptions()}/additionalOrderFields`;
  public static getAdditionalOrderMessageFields = (facilityId: string) => `${EdpURIs.additionalOrderMessageFields()}?facilityId=${encodeURIComponent(facilityId)}`;
  public static deleteAdditionalOrderMessageFields = (fieldId: number, facilityId: string) =>
    `${EdpURIs.additionalOrderMessageFields()}?fieldId=${encodeURIComponent(fieldId)}&facilityId=${encodeURIComponent(facilityId)}`;

  //Ndc Status Codes
  public static facilityNdcStatusCodes = () => `${EdpURIs.facilityOptions()}/ndcStatusCodes`;
  public static getFacilityNdcStatusCodes = (facilityId: string) => `${EdpURIs.facilityNdcStatusCodes()}?facilityId=${encodeURIComponent(facilityId)}`;

  //Pharmacy Endpoints
  public static pharmacy = () => `${EdpURIs.edpBase()}/pharmacies`;
  public static getPharmacy = (pharmacyId: string) => `${EdpURIs.pharmacy()}?id=${encodeURIComponent(pharmacyId)}`;
  public static getPharmacyNdcStatusCodes = () => `${EdpURIs.pharmacy()}/options/ndcStatusCodes`;

  //Order Endpoints
  public static order = () => `${EdpURIs.edpBase()}/orders`;
  public static getOrderByRxNo = (facilityId: string, rxNo: string) => `${EdpURIs.edpBase('2')}/orders/orderByRxNo?facilityId=${facilityId}&rxNo=${rxNo}`;
  public static getFillInformation = (patientId: string, facilityId: string, roNo: string) =>
    `${EdpURIs.edpBase()}/orders/fillInformation?patientId=${encodeURIComponent(patientId)}&facilityId=${encodeURIComponent(facilityId)}&reorderNumber=${encodeURIComponent(roNo)}`;

  //Returns
  public static orderReturns = () => `${EdpURIs.order()}/returns`;
  public static orderReturnsInquiry = (facilityId: string, startDate: string, endDate: string) =>
    `${EdpURIs.orderReturns()}/inquiry?facilityId=${encodeURIComponent(facilityId)}&startDate=${startDate}&endDate=${endDate}`;
  public static orderReturnsPending = () => `${EdpURIs.orderReturns()}/pending`;
  public static orderReturnsProcess = () => `${EdpURIs.orderReturnsPending()}/process`;
  public static getOrderReturnsPending = (facilityId: string) => `${EdpURIs.orderReturnsPending()}?facilityId=${encodeURIComponent(facilityId)}`;
  public static orderReturnsPendingInternal = () => `${EdpURIs.orderReturnsPending()}/internal`;
  public static deleteOrderReturnsPendingInternal = (facilityId: string, itemId: number) =>
    `${EdpURIs.orderReturnsPendingInternal()}?facilityId=${encodeURIComponent(facilityId)}&itemId=${encodeURIComponent(itemId)}`;
  public static orderReturnsPendingExternal = () => `${EdpURIs.orderReturnsPending()}/external`;
  public static deleteOrderReturnsPendingExternal = (facilityId: string, itemId: number) =>
    `${EdpURIs.orderReturnsPendingExternal()}?facilityId=${encodeURIComponent(facilityId)}&itemId=${encodeURIComponent(itemId)}`;

  //Medical Report Endpoints
  public static medicalRecords = () => `${EdpURIs.edpBase()}/medicalrecords`;
  public static dischargeRecord = () => `${EdpURIs.medicalRecords()}/Discharge`;
  public static treatmentSheet = () => `${EdpURIs.medicalRecords()}/treatmentSheet`;
  public static marReport = () => `${EdpURIs.medicalRecords()}/mar`;
  public static assistedDailyLivingReport = () => `${EdpURIs.medicalRecords()}/assistedDailyLiving`;
  public static physicianOrderForm = () => `${EdpURIs.medicalRecords()}/physiciansOrder`;
  public static physicianOrderFormSortOrder = () => `${EdpURIs.physicianOrderForm()}/sortOrders`;
  public static physicianProgressNotes = () => `${EdpURIs.medicalRecords()}/physicianProgressNotes`;
  public static antipsychoticRecord = () => `${EdpURIs.medicalRecords()}/antipsychoticRecord`;
  public static nursingFlowRecord = () => `${EdpURIs.medicalRecords()}/nursingFlowRecord`;
  public static returnPackingLabel = () => `${EdpURIs.medicalRecords()}/returnPackingLabel`;
}
